var render = function render(){var _vm=this,_c=_vm._self._c;return _c('runtime-template',{attrs:{"template":_vm.template}})
}
var staticRenderFns = []

export { render, staticRenderFns }